import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("fixigo_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("fixigo_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("fixigo_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const registerCustomer = async (payload) => {
    const { data } = await api.post("/auth/register-customer", payload);
    localStorage.setItem("fixigo_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("fixigo_token");
    localStorage.removeItem("fixigo_admin_token");
    setUser(null);
    window.location.href = "/login";
  };

  const impersonate = async (userId) => {
    const { data } = await api.post("/auth/impersonate", { user_id: userId });
    const current = localStorage.getItem("fixigo_token");
    if (current && !localStorage.getItem("fixigo_admin_token")) {
      localStorage.setItem("fixigo_admin_token", current);
    }
    localStorage.setItem("fixigo_token", data.access_token);
    const home = data.user.role === "partner" ? "/portal" : data.user.role === "customer" ? "/account" : "/admin";
    window.location.href = home;
    return data.user;
  };

  const stopImpersonating = () => {
    const adminToken = localStorage.getItem("fixigo_admin_token");
    if (!adminToken) return;
    localStorage.setItem("fixigo_token", adminToken);
    localStorage.removeItem("fixigo_admin_token");
    window.location.href = "/users";
  };

  const impersonating = !!localStorage.getItem("fixigo_admin_token");

  return (
    <AuthContext.Provider value={{ user, loading, login, registerCustomer, logout, impersonate, stopImpersonating, impersonating }}>
      {children}
    </AuthContext.Provider>
  );
}

export const can = (user, allowed) => allowed.includes(user?.role);
